import './warnings';
import PropTypes from 'prop-types';
import ForStractionServiceAPI from 'for-straction-service-api';
import { RequestStatus } from '../utils/constants';

const apiPropTypes = {
    networkObjectCustom: PropTypes.shape({
        status: PropTypes.oneOf(Object.values(RequestStatus)).isRequired,
        expires: PropTypes.instanceOf(Date),
        changes: PropTypes.arrayOf(PropTypes.object).isRequired
    }),
    networkObjectOf(type) {
        return PropTypes.shape({
            Data: type,
            Custom: apiPropTypes.networkObjectCustom.isRequired
        });
    },
    networkArrayOf(type) {
        return PropTypes.shape({
            Data: PropTypes.arrayOf(type.isRequired).isRequired,
            Custom: apiPropTypes.networkObjectCustom.isRequired
        });
    },
    paginationSliceOf(type) {
        return PropTypes.shape({
            Data: PropTypes.arrayOf(type.isRequired).isRequired,
            Custom: apiPropTypes.networkObjectCustom.isRequired,
            NextID: PropTypes.number.isRequired,
            TotalCount: PropTypes.number.isRequired
        });
    },
    nestedPaginationSliceOf(type) {
        return PropTypes.shape({
            Data: PropTypes.arrayOf(type.isRequired).isRequired,
            Custom: apiPropTypes.networkObjectCustom.isRequired,
            NextRow: PropTypes.number.isRequired,
            TotalCount: PropTypes.number.isRequired
        });
    }
};

function propTypeFromValue(value) {
    switch (true) {
        case typeof value === 'boolean':
            return PropTypes.bool;
        case typeof value === 'number':
            return PropTypes.number;
        case typeof value === 'string':
            return PropTypes.string;
        case Array.isArray(value):
            return PropTypes.arrayOf(propTypeFromValue(value[0]));
        case !!value?.constructor?.constructFromObject:
            const result = {};
            let instance = { ...value.constructor.prototype };
            for (const i in instance) {
                if (Object.prototype.hasOwnProperty.call(instance, i)) {
                    instance[i] = [[]];
                }
            }
            instance = value.constructor.constructFromObject(instance);
            for (const i in instance) {
                if (Object.prototype.hasOwnProperty.call(instance, i)) {
                    result[i] = typeof instance[i] !== 'object' && value.constructor.prototype[i] !== undefined ? // check warnings.js
                        propTypeFromValue(instance[i]).isRequired :
                        propTypeFromValue(instance[i]);
                }
            }
            result.Custom = apiPropTypes.networkObjectCustom;
            return PropTypes.shape(result);
        default:
            return PropTypes.any;
    }
}

// TODO is it possible to create this stuff during webpack bundling?
for (const i in ForStractionServiceAPI) {
    if (!i.includes('Api')) {
        apiPropTypes[i] = propTypeFromValue(ForStractionServiceAPI[i].constructFromObject({}));
        if (DEBUG) {
            apiPropTypes[i].EntityType = i;
        }
    }
}

apiPropTypes.NewsEntryLightReportPaginationSlice = apiPropTypes.NewsEntryLightReportNewsEntryReportPaginationSlice;

export default apiPropTypes;
